import React, { useState, useEffect, Fragment } from 'react';
import { ListLayout } from '../../containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Menu, MenuItem, Typography, Checkbox, TableSortLabel } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size, sumBy, sum } from 'lodash';
import ClientPopUp from '../../clients/ClientPopUp';
import { amber, cyan, deepPurple, indigo, red } from '@material-ui/core/colors';
import Currency from '../../../../../commonModules/Currency';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import { useSelector } from 'react-redux';

const ListTransferAvoir = (props) => {
    const fetchTransfers = useFetchTransfers("avoir");
	const SHOPS = useSelector((state) => state.inventory.shops); 
	const CLIENTS = useSelector((state) => state.inventory.clients); 
	const AVOIRS = useSelector((state) => state.inventory.avoirs); 
	const AGENTS = useSelector((state) => state.agents.agents); 
	const STATE = useSelector((state) => state.inventory.requestState); 

    const [view, setView] = useState("list");
    const [clientPopUp, setClientPopUp] = useState(false);
    const [avoir, setAvoir] = useState({});
    const [client, setClient] = useState({});
    const [allChecked, setAllChecked] = useState(false);
    const [avoirList,setAvoirList]= useState({});
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [openLink, setOpenLink] = useState(false);

    useEffect(() => {
        console.log("MOUNTING ListTransferAvoirs ");
        fetchTransfers();
    }, []);
    useEffect(() => {
        if (!isEmpty(AVOIRS)){
			const avoirList = displayList();
		    setAvoirList(avoirList)
		}
    }, [AVOIRS]);
    useEffect(() => {
        const avoirList = displayList();
		setAvoirList(avoirList)
    }, [checkedPayments]);
   
    const handleClick = (event, payID) => {
        const selectedIndex = checkedPayments.indexOf(payID);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedPayments, payID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedPayments.slice(1));
        } else if (selectedIndex === checkedPayments.length - 1) {
            newSelected = newSelected.concat(checkedPayments.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedPayments.slice(0, selectedIndex),
                checkedPayments.slice(selectedIndex + 1),
            );
        }

        setCheckedPayments(newSelected);
    };
    const createAvoirList = (list) => {
        const { rowsPerPage, currentPage } = props;
        console.log('====================================');
        console.log({list});
        console.log({AVOIRS});
        console.log({ rowsPerPage, currentPage });
        console.log('====================================');
        const isSelected = name => checkedPayments.indexOf(name) !== -1;

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((avoir, index) => {
            if (avoir) {
                const client = CLIENTS[avoir.client_id];
                const shop = SHOPS[avoir.shop_id];
                const agent = AGENTS && AGENTS[avoir.commercial_id];
                return (
                    <TableRow key={avoir.id} >
                        <Checkbox
                                    onClick={event => handleClick(event, avoir.id)}
                                    checked={isSelected(avoir.id)}
                                    inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                                />
                        <TableCell>{(new Date(avoir.creation_date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>{avoir.nature} </TableCell>
                        <TableCell>
                            {shop ? (
                                <a href="#" onClick={() => props.handleSingleShop(shop)}> {shop.name} </a>
                            ) : (
                                <span>{avoir.shop_id}</span>
                            )}
                        </TableCell>
                        <TableCell>{client &&
                            <a href="#" onClick={() => {setClient(client); setClientPopUp(true)}}>{client.client_firstname} {client.client_lastname}</a>
                        }
                        </TableCell>
                        <TableCell><Currency value={avoir.total_price} /></TableCell>
                        <TableCell>
                            <IconButton
                                color="secondary"
                                onClick={() => props.handleSingleAvoir(avoir, shop, client, agent)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            }
        });
    };

    const displayList = () => {
        let listAll = [];
        let tab = [];
        let rows = 0;
        if (!isEmpty(AVOIRS)) {
            let filteredList = props.getFilteredList();
            rows = size(filteredList);
            tab = createAvoirList(filteredList);
            listAll = filteredList.map(avoir => avoir.id);
        }
        return { list: tab, size: rows, listAll };
    };
    const handleSelectAllClick = (event, list) => {
        const { rowsPerPage, currentPage } = props;
        console.log("handleSelectAllClick >>",event.target.checked)

        if (event && event.target.checked) {
            let newList = list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
            setCheckedPayments(newList);
            setAllChecked(true);
            return;
        }
        setAllChecked(false);
        setCheckedPayments([]);
    };

    return (
        <>
            
            {clientPopUp && !isEmpty(client) &&
                <ClientPopUp
                    client={client}
                    {...props}
                    closePopUp={() => setClientPopUp(false, setClient({}))}
                />
            }

            {size(checkedPayments) > 0 &&
                <Button variant="contained" color="primary" onClick={() => setOpenLink(true)}>
                    Télécharger {size(checkedPayments)} avoirs
                </Button>
            }

            {view === "list" && (
                <Box>
                    <Box>
                            <Box p={1}>
                                <Typography variant="h6">Liste des avoirs</Typography>
                            </Box>
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={size(checkedPayments) > 0 && size(checkedPayments) < avoirList.size}
                                            checked={allChecked}
                                            onChange={(e) => handleSelectAllClick(e, avoirList.listAll)}
                                            inputProps={{ 'aria-label': 'Selectionner tout' }}
                                        />
                                    </TableCell>
                                        <TableCell>
                                            {/* <TableSortLabel
                                                active={true}
                                                direction={sortDSC ? 'desc' : 'asc'}
                                                onClick={() => this.setState({ sortDSC: !this.state.sortDSC})}
                                            >
                                                Date Paiement
                                            </TableSortLabel> */}
                                            Date
                                        </TableCell>
                                        <TableCell>Nature</TableCell>
                                        <TableCell>Shop</TableCell>
                                        <TableCell>Nom Client</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Détails</TableCell>
                                        {/* <TableCell>Options</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { avoirList.size !== 0  && 
                                        avoirList.list
                                    }
                                    { avoirList.size === 0  && 
                                    <TableRow>
                                        <TableCell colSpan={7}>
                                            {/* <div className="text-center">
                                                Cliquez sur{' '}
                                                <Button
                                                    color="primary"
                                                    className="text-right"
                                                    // onClick={() => {
                                                    //     setShowNew(true); 
                                                    //     setBreadcrumb('Nouveau');
                                                    //     // setState({ ...state, showNew: true, breadcrumb: 'Nouveau' });
                                                    // }}
                                                >
                                                    Nouveau
                                                </Button>{' '}
                                                pour entrer une nouvelle Vente
                                            </div> */}
                                        </TableCell>
                                    </TableRow>
                                    }
                                </TableBody>
                                { avoirList.size > 20  && 
                                    <TableFooterPagination 
                                        colSpan={7}
                                        // items={avoirList[0]} 
                                        count={avoirList.size}
                                        onChangePage={props.onChangePage}
                                        initialPage={props.currentPage || 0}
                                        page={props.currentPage}
                                    />         
                                }           
                            </ListLayout>
                        </Box>
                </Box>
            )}
        </>
    );
}

export default ListTransferAvoir;